module.exports = __webpack_public_path__ + "static/media/kettlebell.0eb45f89.svg";